export enum ECommonDialogType {
  HomeClickWarning = 'HomeClickWarning',
  Success = 'Success',
  MultiNumericManipulation = 'multiNumericManipulation',
  Error = 'Error',
  Confirm = 'Confirm',
  Unknown = 'Unknown',
}

export enum EConfirmDialog {
  RemoveEmptySection = 'removeEmptySection',
  DiscardChanges = 'discardChanges',
  DeleteSection = 'deleteSection',
  SaveRequired = 'saveRequiredForObsoleteFeature',
}
